const COLORS = [
  "#1E61DC",
  "#10B981",
  "#F59E0B",
  "#8B5CF6",
  "#EC4899",
  "#6B7280",
];

export function MRRPieChartShimmer({ segments = 6 }) {
  return (
    <>
      <div className="w-full h-[300px] flex items-center justify-center relative">
        {Array.from({ length: segments }).map((_, idx) => (
          <div
            key={idx}
            className="absolute rounded-full animate-pulse"
            style={{
              width: `${80 + idx * 10}px`,
              height: `${80 + idx * 10}px`,
              border: `16px solid ${COLORS[idx % COLORS.length]}20`,
              borderTopColor: COLORS[idx % COLORS.length],
              animation: "spin 1s linear infinite",
            }}
          />
        ))}

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
            }
            `}</style>
      </div>
    </>
  );
}
